import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Avatar from '@mui/material/Avatar';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useNavigate } from 'react-router-dom';

// @mui
import {
    Stack,
    Card,
    Button,
    Container,
    Typography,
    IconButton,
    Box,
    Grid,
    TextField,
    FormControlLabel,
    Switch,
    InputAdornment,
    CardMedia,
    CardHeader,
    CardContent,
    Divider
  } from '@mui/material';

  // components
  import Iconify from '../components/iconify';

  const API_URL = `${process.env.REACT_APP_API_URL}`;


export default function ProfilesPage() {

    const [showUserData, setUserData] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const MySwal = withReactContent(Swal)

    useEffect(() => {
        const token = localStorage.getItem('token');
        const bearer = "Bearer ";
        
        fetch(`${API_URL}/users_email`,{method: 'post',
        headers: {"Content-Type": "application/json", "Authorization": bearer+token},
        }).then(response => response.json())
        .then(data => {
           if(data.status === 'ok'){
             setUserData(data.response)
           }else{
            console.log(data);
           }
        })
    },[])


    const formSchema = Yup.object().shape({
        department: Yup.string()
            .required("Select Department"),
        fname: Yup.string()
        .required('Enter Menu Name'),
        lname: Yup.string()
        .required('Enter Description'),
        email: Yup.string()
        .required('Enter email')
        .email('Must be a valid email')
      
    })

    const formOptions = { resolver: yupResolver(formSchema) }

    const defaultValues ={ 
        id:'',
        fname: '',
        lname:'',
        email: '',
        password: '',
        department: ''
    }

    const {
    register,
    handleSubmit,
    formState: { errors }
    } = useForm(formOptions, {defaultValues} );



    const onSubmit = (data) => {

        const jsonData = {
            id: showUserData[0].id,
            fname: data.fname,
            lname: data.lname,
            email: data.email,
            department: data.department,
            password: data.password
        }

        fetch(`${API_URL}/users_profile`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(jsonData)
        })
          .then(response => response.json())
          .then(data => {
           
            MySwal.fire({
              title: 'บันทึกข้อมูลสำเร็จ',
              text: "success",
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            
          })
          .catch(() =>{
            console.log('Error Connect API !');
          });
          
    }

    const [showCheckBox, setCheckBox] = useState({
        email: false,
        line: false
    });

    const navigate = useNavigate();

    const handleCancel = async e => {
        e.preventDefault();
        navigate("/dashboard");
    }
    


  return (
    <>
     <Helmet>
        <title>Profiles</title>
      </Helmet>
      
      <Container component="main" maxWidth="xl">

        <Card sx={{ maxWidth: "xl",my: 1,borderRadius:5 }}>
            <CardContent >
                <Grid container item spacing={2}  md={12}>
                    <Grid item md={6}>
                        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }} md={6}>

                            {showUserData.map((row,index) =>(

                            <Grid container spacing={2} item  md={12} key={index}>
                                <Grid item xs={12} sm={12} md={12} align='center'>

                                    <Avatar
                                    alt={showUserData.fname}
                                    src="/static/images/avatar/1.jpg"
                                    sx={{ m: 1,width: 180, height: 180 }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                    fullWidth
                                    label="Department"
                                    defaultValue={row.department}
                                    {...register('department')}
                                    helperText={errors.department?.message}
                                    error={Boolean(errors.department && 'error')} 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                    fullWidth
                                    label="First Name"
                                    defaultValue={row.fname}
                                    {...register('fname')}
                                    helperText={errors.fname?.message}
                                    error={Boolean(errors.fname && 'error')} 
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                    fullWidth
                                    id="lname"
                                    label="Last Name"
                                    defaultValue={row.lname}
                                    {...register('lname')}
                                    helperText={errors.lname?.message}
                                    error={Boolean(errors.lname && 'error')} 
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                    fullWidth
                                    id="email"
                                    label="Email Address"
                                    defaultValue={row.email}
                                    {...register('email')}
                                    helperText={errors.email?.message}
                                    error={Boolean(errors.email && 'error')} 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    />
                                </Grid>

                                <Grid item xs={12} >
                                    <TextField fullWidth
                                        label="Password"
                                        type={showPassword ? 'text' : 'password'}
                                        {...register('password')}
                                        helperText={errors.password?.message}
                                        error={Boolean(errors.password && 'error')} 
                                        InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                            </IconButton>
                                            </InputAdornment>
                                        ),
                                        }}
                                />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="center"alignItems="center" >
                                        <Stack direction="row" spacing={1}  sx={{my: 5}}>
                                        <Button type="submit" variant="contained" color='primary' >
                                            Save
                                        </Button>
                                        <Button type="button" variant="contained" color='error' onClick={handleCancel}>
                                            Cancel
                                        </Button>
                                        </Stack>
                                    </Box>
                                </Grid>


                            </Grid>
                            ))}

                        </Box>
                    </Grid>

                    <Grid item md={6}>

                        {showUserData.map((row,index) =>(
                        <Grid container spacing={3} item  md={12} key={index} align='center'>
                            <Grid item  xs={12} sm={12} md={12}>
                                <Typography component="h1" variant='h5'>การส่ง Line-OTP</Typography>
                                <Typography >** กรุณาสแกน QR Code ด้านล่างเพื่อเปิดใช้งาน OTP</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <Card sx={{ maxWidth: 300 }}>
                                    <CardMedia
                                        sx={{ height: 300 }}
                                        image="data:image/png;base64,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"
                                        title=""
                                    />
                                </Card>
                            </Grid>
                            <Grid item sx={{mt: 5}} xs={12} sm={12} md={12}>
                                <Typography component="h1" variant='h5'>ท่านได้ทำการเปิดใช้ OTP ผ่าน</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel control={Boolean(row.email) !== "" && <Switch checked={!showCheckBox.email}/> || <Switch checked={showCheckBox.email}/>} label="Email"/>
                            </Grid>   

                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel control={Boolean(row.lid) !== "" && <Switch checked={!showCheckBox.line}/> || <Switch checked={showCheckBox.line}/>} label="Line"/>
                            </Grid>


                        </Grid>
                        ))}

                    </Grid>
        
                </Grid>

        </CardContent>
        </Card>

      </Container>


 

    </>
   
  );
}